import { render, staticRenderFns } from "./AppFuncList.vue?vue&type=template&id=38fdc31c&scoped=true&"
import script from "./AppFuncList.vue?vue&type=script&lang=js&"
export * from "./AppFuncList.vue?vue&type=script&lang=js&"
import style0 from "./AppFuncList.vue?vue&type=style&index=0&id=38fdc31c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fdc31c",
  null
  
)

export default component.exports